import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

import {
  getOrdersEndDate,
  getOrdersPeriod,
  getOrdersStartDate,
  getUserLocation,
} from "../../redux";
import { HubCardStack, HubTabs } from "../../components";
import {
  JobsTable,
  LineItemsTable,
  OrdersWorkOrderTable,
  PurchaseOrdersTable,
} from "../../tables";

import JobsFilters from "../../tables/JobsTable/JobsFilters";
import { HubButtonGroupSlider } from "../../components";

const tabs = [
  {
    id: 0,
    label: "Work Orders",
    Table: OrdersWorkOrderTable,
  },
  {
    id: 1,
    label: "Purchase Orders",
    Table: PurchaseOrdersTable,
  },
  {
    id: 2,
    label: "Line Items",
    Table: LineItemsTable,
  },
];

const OrdersTableSwitch = ({ defaultLocation, per, startDate, endDate }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(tabs[0].id);
  const props = { value, setValue, tabs };

  useEffect(() => {
    searchParams.delete("orderBy");
    searchParams.delete("sortOrder");
    setSearchParams(searchParams);
  }, [value]);

  const Element = tabs?.find(({ id }) => id === value)?.Table || JobsTable;
  return (
    <HubCardStack
      className="HubOrdersTableSwitch-root"
      gap="15px"
      overflow="hidden"
      position="relative"
    >
      <Stack
        direction="row"
        width="100%"
        justifyContent="space-between"
        gap="15px"
      >
        <HubButtonGroupSlider
          buttons={tabs}
          selected={value}
          setSelected={setValue}
        />
        <JobsFilters />
      </Stack>
      <Element
        {...{ defaultLocation, per, startDate, endDate }}
        prefix=""
        includeCheckbox={false}
      />
    </HubCardStack>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
  per: getOrdersPeriod(state),
  startDate: getOrdersStartDate(state),
  endDate: getOrdersEndDate(state),
});

export default connect(mapStateToProps)(OrdersTableSwitch);
